import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  container: {
    display: 'flex',
    height: 'calc(100vh - 108px)',
    paddingBottom: 15,
    paddingLeft: 30,
  },
  questionsList: {
    maxWidth: '800px',
    minWidth: '75%',
    minHeight: '50%',
    display: 'flex',
    flexDirection: 'column',
  },
  loadMoreContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
  },
});
